import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IRejectCompaniesPayload {
    sharedListId: string
    data: {
        rejectedCompanies: any
    }
    sagaCB?: any
}

export interface IRejectCompaniesState {
    status: string
    data: any
    errors: any
}

const initialState: IRejectCompaniesState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const rejectCompanies = createSlice({
    name: 'sharedList/reject-companies',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IRejectCompaniesPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const rejectCompaniesActions = rejectCompanies.actions
export default rejectCompanies.reducer
